import {FormattedHTMLMessage, useIntl} from "react-intl";
import hotDogImg from "../../../images/wrapped_2024/slides/food_top3/HOT DOG.png";
import burgerImg from "../../../images/wrapped_2024/slides/food_top3/BURGER.png";
import wrapillaImg from "../../../images/wrapped_2024/slides/food_top3/WRAPILLA.png";
import praadImg from "../../../images/wrapped_2024/slides/food_top3/PRAAD.png";
import lasteeineImg from "../../../images/wrapped_2024/slides/food_top3/LASTEEINE.png";
import suppImg from "../../../images/wrapped_2024/slides/food_top3/SUPP.png";
import puderImg from "../../../images/wrapped_2024/slides/food_top3/PUDER.png";
import juustupallImg from "../../../images/wrapped_2024/slides/food_top3/KIIREAMPS-JUUSTUPALL.png";
import React from "react";
import {capitalize} from "../../../helpers/stringHelper";
import slideBg from "../../../images/wrapped_2024/slides/food_top3/Toit vastanduja.png";
import slideBg_2x from "../../../images/wrapped_2024/slides/food_top3/Toit vastanduja@2x.png";
import foreground from "../../../images/wrapped_2024/slides/food_top3/Toit vastanduja 2.png";
import foreground_2x from "../../../images/wrapped_2024/slides/food_top3/Toit vastanduja 2@2x.png";
import hotDogImg_2x from "../../../images/wrapped_2024/slides/food_top3/HOT DOG@2x.png";
import burgerImg_2x from "../../../images/wrapped_2024/slides/food_top3/BURGER@2x.png";
import wrapillaImg_2x from "../../../images/wrapped_2024/slides/food_top3/WRAPILLA@2x.png";
import praadImg_2x from "../../../images/wrapped_2024/slides/food_top3/PRAAD@2x.png";
import lasteeineImg_2x from "../../../images/wrapped_2024/slides/food_top3/LASTEEINE@2x.png";
import puderImg_2x from "../../../images/wrapped_2024/slides/food_top3/PUDER@2x.png";
import suppImg_2x from "../../../images/wrapped_2024/slides/food_top3/SUPP@2x.png";
import juustupallImg_2x from "../../../images/wrapped_2024/slides/food_top3/KIIREAMPS-JUUSTUPALL@2x.png";

export const FoodTop3 = ({data}) => {
    const intl = useIntl();
    const mainFood = data[0].foodEe;
    const mainFoodIsHotDog = mainFood?.includes("HOT DOG");

    const getLocalizedFoodName = (data) => {
        if (intl.locale === "en") return data.foodEn;
        if (intl.locale === "ru") return data.foodRu;
        return data.foodEe;
    }

    const renderImage = (data) => {
        let image;
        let image_2x;
        if (data.group.includes("HOT DOG")) {
            image = hotDogImg;
            image_2x = hotDogImg_2x;
        }
        if (data.group.includes("BURGER")) {
            image = burgerImg;
            image_2x = burgerImg_2x;
        }
        if (data.group.includes("WRAPILLA")) {
            image = wrapillaImg;
            image_2x = wrapillaImg_2x;
        }
        if (data.group.includes("PRAED")) {
            image = praadImg;
            image_2x = praadImg_2x;
        }
        if (data.group.includes("LASTEEINED")) {
            image = lasteeineImg;
            image_2x = lasteeineImg_2x;
        }
        if (data.group.includes("PUDER")) {
            image = puderImg;
            image_2x = puderImg_2x;
        }
        if (data.group.includes("SUPID")) {
            image = suppImg;
            image_2x = suppImg_2x;
        }
        if (data.group.includes("AMPSUD")) {
            image = juustupallImg;
            image_2x = juustupallImg_2x;
        }

        if (!image) {
            return null;
        }

        return <img src={image} srcSet={`${image} 1x, ${image_2x} 2x`} alt='food-bg'/>;
    }

    return (
        <div className='wrapped__carousel-slide wrapped__food-top3'>
            <div className='wrapped__food-top3__content'>
                <h1><FormattedHTMLMessage
                    id={mainFoodIsHotDog ? "Wrapped2024.FoodTop3.Popular" : "Wrapped2024.FoodTop3.AgainstTheCurrent"}/>
                </h1>
                <div className="imageFrame">{renderImage(data[0])}</div>

                <div className="tableWrapper">
                    <h1><FormattedHTMLMessage id="Wrapped2024.FoodTop3.Top3"/></h1>
                    <div className="row">
                        <p>1. {capitalize(getLocalizedFoodName(data[0]).toLowerCase())}</p>
                        <p>{data[0].count} <FormattedHTMLMessage id="Wrapped2024.General.Piece"/></p>
                    </div>
                    {data.length >= 2 &&
                        <div className="row">
                            <p>2. {capitalize(getLocalizedFoodName(data[1]).toLowerCase())}</p>
                            <p>{data[1].count} <FormattedHTMLMessage id="Wrapped2024.General.Piece"/></p>
                        </div>
                    }
                    {data.length >= 3 &&
                        <div className="row">
                            <p>3. {capitalize(getLocalizedFoodName(data[2]).toLowerCase())}</p>
                            <p>{data[2].count} <FormattedHTMLMessage id="Wrapped2024.General.Piece"/></p>
                        </div>
                    }
                </div>
            </div>

            <img src={slideBg} srcSet={`${slideBg} 1x, ${slideBg_2x} 2x`} alt='slide-bg'
                 className='wrapped__carousel-slide__background'/>
            <img src={foreground} srcSet={`${foreground} 1x, ${foreground_2x} 2x`}
                 className="wrapped__carousel-slide__foreground" alt='slide-bg'/>
        </div>
    );
}